import { cai, sui, xrp, solana } from '../asset/images';
import ethereumIcon from '../asset/svg/ethereum.svg';
import monIcon from '../asset/images/chain/MON.png';
import { EVMChain, SVMChain } from '@cai/shared/types';
import { DEFAULT_DAPP_STATE } from '@cai/shared/dapp';
import { getDisplayLabel, getNativeSymbol, NETWORK_DEFINITIONS } from '@cai/shared/networks';
import { isEVMChain } from '@cai/shared/wallet';
export { isEVMChain, DEFAULT_DAPP_STATE, getDisplayLabel, getNativeSymbol, NETWORK_DEFINITIONS };
const NETWORK_UI = {
    [EVMChain.Ethereum]: {
        image: ethereumIcon,
        description: 'Ethereum mainnet',
        color: '#627EEA',
        glowColor: 'rgba(98, 126, 234, 0.6)',
    },
    [EVMChain.Monad]: {
        image: monIcon,
        description: 'Monad mainnet',
        color: '#836EF9',
        glowColor: 'rgba(131, 110, 249, 0.6)',
    },
    [SVMChain.Solana]: {
        image: cai,
        description: 'A Solana based AI token',
        color: '#7B61FF',
        glowColor: 'rgba(123, 97, 255, 0.6)',
    },
};
export const NATIVE_TOKEN = [
    ...NETWORK_DEFINITIONS.map((definition) => ({
        name: definition.network,
        symbol: definition.nativeSymbol,
        displayLabel: getDisplayLabel(definition.network),
        image: NETWORK_UI[definition.network]?.image,
        description: NETWORK_UI[definition.network]?.description ?? definition.network,
        color: NETWORK_UI[definition.network]?.color ?? '#AFAFAF',
        glowColor: NETWORK_UI[definition.network]?.glowColor ?? 'rgba(117, 117, 117, 0.6)',
    })),
    {
        name: 'Sui',
        symbol: 'SUI',
        displayLabel: 'SUI',
        image: sui,
        description: 'Layer 1 blockchain designed for asset ownership',
        color: '#6FBCF0',
        glowColor: 'rgba(111, 188, 240, 0.6)',
    },
    {
        symbol: 'XRP',
        name: 'XRPRipple',
        displayLabel: 'XRP',
        image: xrp,
        description: 'Platform for dapps and custom blockchain networks',
        color: '#AFAFAF',
        glowColor: 'rgba(117, 117, 117, 0.6)',
    },
];
export const NETWORK_IMAGES = {
    ...NATIVE_TOKEN.map((item) => ({ [item.name]: item.image })).reduce((acc, cur) => ({ ...acc, ...cur }), {}),
    [SVMChain.Solana]: solana,
};
export const getChainInfoByName = (name) => {
    return NATIVE_TOKEN.find((native) => native.name === name);
};
